import type * as api from '@gitbook/api-client';
import { Block, Fragment } from '@gitbook/slate';

import { createParagraph } from '../paragraph';
import { BLOCK_DRAWING, FRAGMENT_CAPTION } from '../types';

/**
 * Create a drawing block.
 */
export function createDrawingBlock(ref: api.ContentRefFile | undefined = undefined, caption = '') {
    return Block.createVoid({
        type: BLOCK_DRAWING,
        data: {
            ref,
        },
        fragments: [
            Fragment.create({
                fragment: FRAGMENT_CAPTION,
                nodes: [createParagraph(caption)],
            }),
        ],
    });
}
